export default __webpack_public_path__ + "static/media/Navigation.752ea2c7.svg";